import {createRouter, createWebHistory} from 'vue-router'
import {useRequest} from "@/composables/useRequest";
import {TOKEN} from "@/constants";
import {decryptData} from "@/utilities/crypto";

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('../views/rebuild/login/LoginPageRebuild.vue')
    },
    {
        path: '/home',
        name: 'landingPage',
        redirect: {name: 'dashboardPage'},
        meta: {requiresAuth: true},
        component: () => import('../views/rebuild/ContentWrapperRebuild.vue'),
        children: [
            {
                path: 'home',
                name: 'dashboardPage',
                component: () => import('../views/rebuild/dashboard/DashboardPage.vue'),
            },
            {
                path: 'attendance',
                name: 'attendancePage',
                component: () => import('../views/rebuild/attendace/AttendancePageRebuild.vue'),
            },
            {
                path: 'attendance-list',
                name: 'attendanceSummaryPage',
                component: () => import('../views/Attendance/AttendanceList.vue'),
            },
            {
                path: 'overtime',
                name: 'overtimeApplicationPage',
                redirect: {name: 'overtimeApplicationList'},
                component: () => import('../components/layout/Container.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'overtimeApplicationList',
                        component: () => import('../views/rebuild/application-forms/OvertimeApplicationRebuild.vue'),
                    },
                    {
                        path: ':code',
                        name: 'overtimeApplicationDetails',
                        props: true,
                        component: () => import('../views/rebuild/application-forms/OvertimeApplicationFormRebuild.vue'),
                    }
                ]
            },
            {
                path: 'leaves',
                name: 'leaveApplicationPage',
                redirect: {name: 'leaveApplicationList'},
                component: () => import('../components/layout/Container.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'leaveApplicationList',
                        component: () => import('../views/rebuild/application-forms/LeaveApplicationRebuild.vue'),
                    },
                    {
                        path: ':code',
                        name: 'leaveApplicationDetails',
                        component: () => import('../views/rebuild/application-forms/LeaveApplicationFormRebuild.vue'),
                    }
                ]
            },
            {
                path: 'profile',
                name: 'profilePage',
                component: () => import('../views/rebuild/Profile/ProfilePageRebuild.vue'),
            },
            {
                path: 'account',
                name: 'accountPage',
                component: () => import('../views/rebuild/user-data/AccountPage.vue'),
            },
            {
                path: 'biometrics',
                name: 'biometricsPage',
                component: () => import('../views/Setup/AllowBiometrics.vue'),
            },
            {
                path: 'passwords',
                name: 'passwordManagement',
                component: () => import('../views/Setup/PasswordManagement.vue'),
            },
            {
                path: 'setting',
                name: 'settings',
                component: () => import('../views/rebuild/settings/Settings.vue'),
            },
            {
                path: 'users',
                name: 'usersPage',
                component: () => import('../views/Applications/LeaveApplication.vue'),
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'Page404',
        component: () => import('../views/misc/PageNotFound.vue'),
    },
    {
        path: '/unauthorized',
        name: 'accessDenied',
        component: () => import('@/views/misc/PageUnauthorizedAccess.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

router.beforeEach(async(to, from, next) => {
    const USER_TOKEN = decryptData(localStorage.getItem(TOKEN))
    const EXPIRY = decryptData(localStorage.getItem("expirationLimit"))
    if(to.meta.requiresAuth) {
        if (!USER_TOKEN && to.name !== "login") return next({name: "index"})
        else next()
        let expirationDate = Date.parse(EXPIRY);

        if (Date.now() > expirationDate) {
            await useRequest().logout()
            return next({name: "index"})
        }
    } else if(USER_TOKEN && to.name === 'index') {
        next({name: 'landingPage'})
    } else next()
})


export default router